<template>
  <!-- 文本域行数设置
       @author: liuguisheng
       @date: 2019-9-20
   -->
  <div class="setting-item">
    <el-form-item label="最小行数"> 
        <el-input type="text" 
                  v-model.number="minRows"
                  placeholder="请输入最小行数">
        </el-input> 
    </el-form-item>
    <el-form-item label="最大行数"> 
        <el-input type="text" 
                  v-model.number="maxRows"
                  placeholder="请输入最大行数">
        </el-input>
    </el-form-item>

  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 自适应高度
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-09-20
     */
    ...mapComputed({
      minRows: { 
        parent: i => i.baseOption,
        attr: "autosizeMinRows" 
      },
      maxRows: {
        parent: i => i.baseOption,
        attr: "autosizeMaxRows"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingAutosize.vue